import { z } from 'zod';

// Regex patterns
const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const PHONE_REGEX = /^[0-9+()\-\s]+$/;

/**
 * Email validation schema (required)
 * - Required field
 * - Valid email format
 * - Maximum 100 characters
 */
export const emailSchema = z
  .string()
  .min(1, 'El correo electrónico es requerido')
  .regex(EMAIL_REGEX, 'El formato del correo electrónico no es válido')
  .max(100, 'El correo electrónico no puede exceder 100 caracteres');

/**
 * Email validation schema (optional)
 * - Optional field (can be empty or null)
 * - Valid email format when provided
 * - Maximum 100 characters
 */
export const emailOptionalSchema = z
  .union([z.string(), z.null()])
  .optional()
  .refine(
    (value) => {
      if (!value || value.trim() === '') return true;
      return EMAIL_REGEX.test(value) && value.length <= 100;
    },
    { message: 'El formato del correo electrónico no es válido o excede 100 caracteres' },
  )
  .transform((value) => value?.trim() || '');

/**
 * Phone number validation schema (required)
 * - Required field
 * - Valid phone format (numbers, +, (), -, spaces)
 * - Maximum 20 characters
 */
export const phoneSchema = z
  .string()
  .min(1, 'El número de teléfono es requerido')
  .max(20, 'El número de teléfono no puede exceder 20 caracteres')
  .regex(
    PHONE_REGEX,
    'El formato del número de teléfono no es válido (solo números, +, (), -, espacios)',
  );

/**
 * Phone number validation schema (optional)
 * - Optional field (can be empty or null)
 * - Valid phone format when provided (numbers, +, (), -, spaces)
 * - Maximum 20 characters
 */
export const phoneOptionalSchema = z
  .union([z.string(), z.null()])
  .optional()
  .refine(
    (value) => {
      if (!value || value.trim() === '') return true; // Optional field
      if (value.length > 20) return false; // Max length
      return PHONE_REGEX.test(value); // Format validation
    },
    { message: 'El teléfono no es válido (máx. 20 caracteres, solo números, +, (), -, espacios)' },
  )
  .transform((value) => value?.trim() || '');
